// extracted by mini-css-extract-plugin
export default {"parent":"NoWork_parent__ENvIy","child":"NoWork_child__Ct1uw","content":"NoWork_content__Oenfb"};